let countryArrAll = [{
  'label': 'United States of America',
  'value': '+1(US)'
}, {
  'label': 'Canada',
  'value': '+1(CA)'
}, {
  'label': 'United Kingdom',
  'value': '+44(UK)'
}, {
  'label': 'Australia',
  'value': '+61(AU)'
}, {
  'label': 'Austria',
  'value': '+43(AT)'
}, {
  'label': 'Belgium',
  'value': '+32(BE)'
}, {
  'label': 'Denmark',
  'value': '+45(DK)'
}, {
  'label': 'Finland',
  'value': '+358(FI)'
}, {
  'label': 'France',
  'value': '+33(FR)'
}, {
  'label': 'Germany',
  'value': '+49(DE)'
}, {
  'label': 'Ireland',
  'value': '+353(IE)'
}, {
  'label': 'Italy',
  'value': '+39'
}, {
  'label': 'Luxembourg',
  'value': '+352(LU)'
}, {
  'label': 'Netherlands',
  'value': '+31(NL)'
}, {
  'label': 'Northern Ireland',
  'value': '+44 28'
}, {
  'label': 'Norway',
  'value': '+47(NO)'
}, {
  'label': 'Spain',
  'value': '+34(ES)'
}, {
  'label': 'Sweden',
  'value': '+46(SE)'
}, {
  'label': 'Switzerland',
  'value': '+41(CH)'
}, {
  'label': 'Afghanistan',
  'value': '+93(AF)'
}, {
  'label': 'Albania',
  'value': '+355(AL)'
}, {
  'label': 'Algeria',
  'value': '+213(DZA)'
}, {
  'label': 'American Samoa',
  'value': '+1 684'
}, {
  'label': 'Andorra',
  'value': '+376(AD)'
}, {
  'label': 'Angola',
  'value': '+244(AO)'
}, {
  'label': 'Anguilla',
  'value': '+1 264(AI)'
}, {
  'label': 'Antigua and Barbuda',
  'value': '+1 268(AG)'
}, {
  'label': 'Argentina',
  'value': '+54(AR)'
}, {
  'label': 'Armenia',
  'value': '+374(AM)'
}, {
  'label': 'Aruba',
  'value': '+297'
}, {
  'label': 'Ascension',
  'value': '+247(AC)'
}, {
  'label': 'Australian Antarctic Territory',
  'value': '+672 1'
}, {
  'label': 'Australian External Territories',
  'value': '+672'
}, {
  'label': 'Azerbaijan',
  'value': '+994(AZ)'
}, {
  'label': 'Bahamas',
  'value': '+1 242(BS)'
}, {
  'label': 'Bahrain',
  'value': '+973(BH)'
}, {
  'label': 'Bangladesh',
  'value': '+880(BD)'
}, {
  'label': 'Barbados',
  'value': '+1 246(BB)'
}, {
  'label': 'Barbuda',
  'value': '+1 268(AG)'
}, {
  'label': 'Belarus',
  'value': '+375(BY)'
}, {
  'label': 'Belize',
  'value': '+501(BZ)'
}, {
  'label': 'Benin',
  'value': '+229(BJ)'
}, {
  'label': 'Bermuda',
  'value': '+1 441(BM)'
}, {
  'label': 'Bhutan',
  'value': '+975'
}, {
  'label': 'Bolivia',
  'value': '+591(BO)'
}, {
  'label': 'Bonaire',
  'value': '+599 7'
}, {
  'label': 'Bosnia and Herzegovina',
  'value': '+387'
}, {
  'label': 'Botswana',
  'value': '+267(BW)'
}, {
  'label': 'Brazil',
  'value': '+55(BR'
}, {
  'label': 'British Indian Ocean Territory',
  'value': '+246'
}, {
  'label': 'British Virgin Islands',
  'value': '+1 284'
}, {
  'label': 'Brunei Darussalam',
  'value': '+673(BN)'
}, {
  'label': 'Bulgaria',
  'value': '+359(BG)'
}, {
  'label': 'Burkina Faso',
  'value': '+226(BF)'
}, {
  'label': 'Burundi',
  'value': '+257(BI)'
}, {
  'label': 'Cambodia',
  'value': '+855(KH)'
}, {
  'label': 'Cameroon',
  'value': '+237(CM)'
}, {
  'label': 'Cape Verde',
  'value': '+238'
}, {
  'label': 'Caribbean Netherlands',
  'value': '+599 3'
}, {
  'label': 'Caribbean Netherlands',
  'value': '+599 4'
}, {
  'label': 'Caribbean Netherlands',
  'value': '+599 7'
}, {
  'label': 'Cayman Islands',
  'value': '+1 345(KY)'
}, {
  'label': 'Central African Republic',
  'value': '+236(CF)'
}, {
  'label': 'Chad',
  'value': '+235(TD)'
}, {
  'label': 'Chatham Island, New Zealand',
  'value': '+64(NZ)'
}, {
  'label': 'Chile',
  'value': '+56(CL)'
}, {
  'label': 'China',
  'value': '+86(CN)'
}, {
  'label': 'Christmas Island',
  'value': '+61 89164'
}, {
  'label': 'Cocos (Keeling) Islands',
  'value': '+61 89162'
}, {
  'label': 'Colombia',
  'value': '+57(CO)'
}, {
  'label': 'Comoros',
  'value': '+269'
}, {
  'label': 'Congo',
  'value': '+242(CG)'
}, {
  'label': 'Congo, Democratic Republic of the (Zaire)',
  'value': '+243(ZR)'
}, {
  'label': 'Cook Islands',
  'value': '+682(CK)'
}, {
  'label': 'Costa Rica',
  'value': '+506(CR)'
}, {
  'label': 'Croatia',
  'value': '+385'
}, {
  'label': 'Cuba',
  'value': '+53(CU)'
}, {
  'label': 'Curaçao',
  'value': '+599 9'
}, {
  'label': 'Cyprus',
  'value': '+357(CY)'
}, {
  'label': 'Czech Republic',
  'value': '+420(CZ)'
}, {
  'label': 'Diego Garcia',
  'value': '+246'
}, {
  'label': 'Djibouti',
  'value': '+253(DJ)'
}, {
  'label': 'Dominica',
  'value': '+1 767'
}, {
  'label': 'Dominican Republic',
  'value': '+1 809(DOM)'
}, {
  'label': 'Dominican Republic',
  'value': '+1 829(DOM)'
}, {
  'label': 'Dominican Republic',
  'value': '+1 849(DOM)'
}, {
  'label': 'EMSAT (Mobile Satellite service)',
  'value': '+882 13'
}, {
  'label': 'East Timor',
  'value': '+670'
}, {
  'label': 'Easter Island',
  'value': '+56'
}, {
  'label': 'Ecuador',
  'value': '+593(EC)'
}, {
  'label': 'Egypt',
  'value': '+20(EG)'
}, {
  'label': 'El Salvador',
  'value': '+503(SV)'
}, {
  'label': 'Ellipso (Mobile Satellite service)',
  'value': '+881 2'
}, {
  'label': 'Ellipso (Mobile Satellite service)',
  'value': '+881 3'
}, {
  'label': 'Equatorial Guinea',
  'value': '+240'
}, {
  'label': 'Eritrea',
  'value': '+291'
}, {
  'label': 'Estonia',
  'value': '+372(EE)'
}, {
  'label': 'Ethiopia',
  'value': '+251(ET)'
}, {
  'label': 'Falkland Islands',
  'value': '+500'
}, {
  'label': 'Faroe Islands',
  'value': '+298'
}, {
  'label': 'Fiji',
  'value': '+679(FJ)'
}, {
  'label': 'French Antilles',
  'value': '+596(SBH)'
}, {
  'label': 'French Guiana',
  'value': '+594(GF)'
}, {
  'label': 'French Polynesia',
  'value': '+689(PF)'
}, {
  'label': 'Gabon',
  'value': '+241(GA)'
}, {
  'label': 'Gambia',
  'value': '+220(GM)'
}, {
  'label': 'Georgia',
  'value': '+995(GE)'
}, {
  'label': 'Ghana',
  'value': '+233(GH)'
}, {
  'label': 'Gibraltar',
  'value': '+350(GI)'
}, {
  'label': 'Global Mobile Satellite System (GMSS)',
  'value': '+881'
}, {
  'label': 'Globalstar (Mobile Satellite Service)',
  'value': '+881 8'
}, {
  'label': 'Globalstar (Mobile Satellite Service)',
  'value': '+881 9'
}, {
  'label': 'Greece',
  'value': '+30(GR)'
}, {
  'label': 'Greenland',
  'value': '+299'
}, {
  'label': 'Grenada',
  'value': '+1 473'
}, {
  'label': 'Guadeloupe',
  'value': '+590'
}, {
  'label': 'Guam',
  'value': '+1 671(GU)'
}, {
  'label': 'Guatemala',
  'value': '+502(GT)'
}, {
  'label': 'Guernsey',
  'value': '+44 1481'
}, {
  'label': 'Guernsey',
  'value': '+44 7781'
}, {
  'label': 'Guernsey',
  'value': '+44 7839'
}, {
  'label': 'Guernsey',
  'value': '+44 7911'
}, {
  'label': 'Guinea',
  'value': '+224(GN)'
}, {
  'label': 'Guinea-Bissau',
  'value': '+245'
}, {
  'label': 'Guyana',
  'value': '+592(GY)'
}, {
  'label': 'Haiti',
  'value': '+509(HT)'
}, {
  'label': 'Honduras',
  'value': '+504(HN)'
}, {
  'label': 'Hong Kong',
  'value': '+852(HK)'
}, {
  'label': 'Hungary',
  'value': '+36(HU)'
}, {
  'label': 'ICO Global (Mobile Satellite Service)',
  'value': '+881 0'
}, {
  'label': 'ICO Global (Mobile Satellite Service)',
  'value': '+881 1'
}, {
  'label': 'Iceland',
  'value': '+354(IS)'
}, {
  'label': 'India',
  'value': '+91(IN)'
}, {
  'label': 'Indonesia',
  'value': '+62(ID)'
}, {
  'label': 'Inmarsat SNAC',
  'value': '+870'
}, {
  'label': 'International Freephone Service (UIFN)',
  'value': '+800'
}, {
  'label': 'International Networks',
  'value': '+882'
}, {
  'label': 'International Networks',
  'value': '+883'
}, {
  'label': 'International Premium Rate Service',
  'value': '+979'
}, {
  'label': 'International Shared Cost Service (ISCS)',
  'value': '+808'
}, {
  'label': 'Iran',
  'value': '+98(IR)'
}, {
  'label': 'Iraq',
  'value': '+964(IQ'
}, {
  'label': 'Iridium (Mobile Satellite service)',
  'value': '+881 6'
}, {
  'label': 'Iridium (Mobile Satellite service)',
  'value': '+881 7'
}, {
  'label': 'Isle of Man',
  'value': '+44 1624'
}, {
  'label': 'Isle of Man',
  'value': '+44 7524'
}, {
  'label': 'Isle of Man',
  'value': '+44 7624'
}, {
  'label': 'Isle of Man',
  'value': '+44 7924'
}, {
  'label': 'Israel',
  'value': '+972(IL)'
}, {
  'label': 'Ivory Coast',
  'value': '+225(IV)'
}, {
  'label': 'Jamaica',
  'value': '+1 876(JM)'
}, {
  'label': 'Jan Mayen',
  'value': '+47 79'
}, {
  'label': 'Japan',
  'value': '+81(JP)'
}, {
  'label': 'Jersey',
  'value': '+44 1534'
}, {
  'label': 'Jordan',
  'value': '+962(JO)'
}, {
  'label': 'Kazakhstan',
  'value': '+7 6'
}, {
  'label': 'Kazakhstan',
  'value': '+7 7'
}, {
  'label': 'Kenya',
  'value': '+254(KE)'
}, {
  'label': 'Kiribati',
  'value': '+686'
}, {
  'label': 'Korea, North',
  'value': '+850(KP)'
}, {
  'label': 'Korea, South',
  'value': '+82(KR)'
}, {
  'label': 'Kosovo',
  'value': '+383'
}, {
  'label': 'Kuwait',
  'value': '+965(KW)'
}, {
  'label': 'Kyrgyzstan',
  'value': '+996'
}, {
  'label': 'Laos',
  'value': '+856(LA)'
}, {
  'label': 'Latvia',
  'value': '+371(LV)'
}, {
  'label': 'Lebanon',
  'value': '+961(LB)'
}, {
  'label': 'Lesotho',
  'value': '+266(LS)'
}, {
  'label': 'Liberia',
  'value': '+231(LR)'
}, {
  'label': 'Libya',
  'value': '+218(LY)'
}, {
  'label': 'Liechtenstein',
  'value': '+423(LI)'
}, {
  'label': 'Lithuania',
  'value': '+370(LT)'
}, {
  'label': 'Macau',
  'value': '+853(MO)'
}, {
  'label': 'Madagascar',
  'value': '+261(MG)'
}, {
  'label': 'Malawi',
  'value': '+265(MW)'
}, {
  'label': 'Malaysia',
  'value': '+60(MY)'
}, {
  'label': 'Maldives',
  'value': '+960(MV)'
}, {
  'label': 'Mali',
  'value': '+223(ML)'
}, {
  'label': 'Malta',
  'value': '+356(MT)'
}, {
  'label': 'Marshall Islands',
  'value': '+692'
}, {
  'label': 'Martinique',
  'value': '+596'
}, {
  'label': 'Mauritania',
  'value': '+222'
}, {
  'label': 'Mauritius',
  'value': '+230(MU)'
}, {
  'label': 'Mayotte',
  'value': '+262 269'
}, {
  'label': 'Mayotte',
  'value': '+262 639'
}, {
  'label': 'Mexico',
  'value': '+52(MX)'
}, {
  'label': 'Micronesia, Federated States of',
  'value': '+691'
}, {
  'label': 'Midway Island, USA',
  'value': '+1 808'
}, {
  'label': 'Moldova',
  'value': '+373(MD)'
}, {
  'label': 'Monaco',
  'value': '+377(MC)'
}, {
  'label': 'Mongolia',
  'value': '+976(MN)'
}, {
  'label': 'Montenegro',
  'value': '+382'
}, {
  'label': 'Montserrat',
  'value': '+1 664(MS)'
}, {
  'label': 'Morocco',
  'value': '+212(MA)'
}, {
  'label': 'Mozambique',
  'value': '+258(MZ)'
}, {
  'label': 'Myanmar',
  'value': '+95(MM)'
}, {
  'label': 'Nagorno-Karabakh',
  'value': '+374 47'
}, {
  'label': 'Nagorno-Karabakh',
  'value': '+374 97'
}, {
  'label': 'Namibia',
  'value': '+264(NA)'
}, {
  'label': 'Nauru',
  'value': '+674(NR)'
}, {
  'label': 'Nepal',
  'value': '+977(NP)'
}, {
  'label': 'Nevis',
  'value': '+1 869'
}, {
  'label': 'New Caledonia',
  'value': '+687'
}, {
  'label': 'New Zealand',
  'value': '+64'
}, {
  'label': 'Nicaragua',
  'value': '+505(NI)'
}, {
  'label': 'Niger',
  'value': '+227(NE)'
}, {
  'label': 'Nigeria',
  'value': '+234(NG)'
}, {
  'label': 'Niue',
  'value': '+683'
}, {
  'label': 'Norfolk Island',
  'value': '+672 3'
}, {
  'label': 'North Macedonia',
  'value': '+389'
}, {
  'label': 'Northern Cyprus',
  'value': '+90 392'
}, {
  'label': 'Northern Mariana Islands',
  'value': '+1 670(CNMI)'
}, {
  'label': 'Oman',
  'value': '+968(OM)'
}, {
  'label': 'Pakistan',
  'value': '+92(PK)'
}, {
  'label': 'Palau',
  'value': '+680'
}, {
  'label': 'Palestine, State of',
  'value': '+970'
}, {
  'label': 'Panama',
  'value': '+507(PA)'
}, {
  'label': 'Papua New Guinea',
  'value': '+675(PG)'
}, {
  'label': 'Paraguay',
  'value': '+595(PY)'
}, {
  'label': 'Peru',
  'value': '+51(PE'
}, {
  'label': 'Philippines',
  'value': '+63(PH)'
}, {
  'label': 'Pitcairn Islands',
  'value': '+64'
}, {
  'label': 'Poland',
  'value': '+48(PL)'
}, {
  'label': 'Portugal',
  'value': '+351(PT)'
}, {
  'label': 'Puerto Rico',
  'value': '+1 787(PR)'
}, {
  'label': 'Puerto Rico',
  'value': '+1 939(PR)'
}, {
  'label': 'Qatar',
  'value': '+974(QA)'
}, {
  'label': 'Romania',
  'value': '+40(RO)'
}, {
  'label': 'Russia',
  'value': '+7(RU)'
}, {
  'label': 'Rwanda',
  'value': '+250'
}, {
  'label': 'Réunion',
  'value': '+262'
}, {
  'label': 'Saba',
  'value': '+599 4'
}, {
  'label': 'Saint Barthélemy',
  'value': '+590'
}, {
  'label': 'Saint Helena',
  'value': '+290'
}, {
  'label': 'Saint Kitts and Nevis',
  'value': '+1 869'
}, {
  'label': 'Saint Lucia',
  'value': '+1 758(LC)'
}, {
  'label': 'Saint Martin (France)',
  'value': '+590'
}, {
  'label': 'Saint Pierre and Miquelon',
  'value': '+508'
}, {
  'label': 'Saint Vincent and the Grenadines',
  'value': '+1 784(VC)'
}, {
  'label': 'Samoa',
  'value': '+685(WS)'
}, {
  'label': 'San Marino',
  'value': '+378(SM)'
}, {
  'label': 'Saudi Arabia',
  'value': '+966(SA)'
}, {
  'label': 'Senegal',
  'value': '+221(SN)'
}, {
  'label': 'Serbia',
  'value': '+381(YU)'
}, {
  'label': 'Seychelles',
  'value': '+248(SC)'
}, {
  'label': 'Sierra Leone',
  'value': '+232(SL)'
}, {
  'label': 'Singapore',
  'value': '+65(SG)'
}, {
  'label': 'Sint Eustatius',
  'value': '+599 3'
}, {
  'label': 'Sint Maarten (Netherlands)',
  'value': '+1 721'
}, {
  'label': 'Slovakia',
  'value': '+421(SK)'
}, {
  'label': 'Slovenia',
  'value': '+386(SI)'
}, {
  'label': 'Solomon Islands',
  'value': '+677(SB)'
}, {
  'label': 'Somalia',
  'value': '+252(SO)'
}, {
  'label': 'South Africa',
  'value': '+27(ZA)'
}, {
  'label': 'South Georgia and the South Sandwich Islands',
  'value': '+500'
}, {
  'label': 'South Ossetia',
  'value': '+995 34'
}, {
  'label': 'South Sudan',
  'value': '+211'
}, {
  'label': 'Sri Lanka',
  'value': '+94(LK)'
}, {
  'label': 'Sudan',
  'value': '+249(SD)'
}, {
  'label': 'Suriname',
  'value': '+597(SR)'
}, {
  'label': 'Svalbard',
  'value': '+47 79'
}, {
  'label': 'Syria',
  'value': '+963(SY)'
}, {
  'label': 'São Tomé and Príncipe',
  'value': '+239'
}, {
  'label': 'Taiwan',
  'value': '+886(TW)'
}, {
  'label': 'Tajikistan',
  'value': '+992(TJ)'
}, {
  'label': 'Tanzania',
  'value': '+255(TZ)'
}, {
  'label': 'Telecommunications for Disaster Relief by OCHA',
  'value': '+888'
}, {
  'label': 'Thailand',
  'value': '+66(TH)'
}, {
  'label': 'Thuraya (Mobile Satellite service)',
  'value': '+882 16'
}, {
  'label': 'Togo',
  'value': '+228(TG)'
}, {
  'label': 'Tokelau',
  'value': '+690'
}, {
  'label': 'Tonga',
  'value': '+676(TO)'
}, {
  'label': 'Transnistria',
  'value': '+373 2'
}, {
  'label': 'Transnistria',
  'value': '+373 5'
}, {
  'label': 'Trinidad and Tobago',
  'value': '+1 868'
}, {
  'label': 'Tristan da Cunha',
  'value': '+290 8'
}, {
  'label': 'Tunisia',
  'value': '+216(TN)'
}, {
  'label': 'Turkey',
  'value': '+90(TR)'
}, {
  'label': 'Turkmenistan',
  'value': '+993(TM)'
}, {
  'label': 'Turks and Caicos Islands',
  'value': '+1 649'
}, {
  'label': 'Tuvalu',
  'value': '+688'
}, {
  'label': 'US Virgin Islands',
  'value': '+1 340'
}, {
  'label': 'Uganda',
  'value': '+256(UG)'
}, {
  'label': 'Ukraine',
  'value': '+380(UA)'
}, {
  'label': 'United Arab Emirates',
  'value': '+971(AE)'
}, {
  'label': 'Universal Personal Telecommunications (UPT)',
  'value': '+878'
}, {
  'label': 'Uruguay',
  'value': '+598(UY)'
}, {
  'label': 'Uzbekistan',
  'value': '+998'
}, {
  'label': 'Vanuatu',
  'value': '+678'
}, {
  'label': 'Vatican City',
  'value': '+379(VA)'
}, {
  'label': 'Venezuela',
  'value': '+58(VE)'
}, {
  'label': 'Vietnam',
  'value': '+84(VN)'
}, {
  'label': 'Wake Island, USA',
  'value': '+1 808'
}, {
  'label': 'Wallis and Futuna',
  'value': '+681'
}, {
  'label': 'Yemen',
  'value': '+967(YE)'
}, {
  'label': 'Zambia',
  'value': '+260(ZM)'
}, {
  'label': 'Zanzibar',
  'value': '+255 24'
}, {
  'label': 'Zimbabwe',
  'value': '+63'
}, {
  'label': 'eSwatini',
  'value': '+268(SZ)'
}, {
  'label': 'Åland Islands',
  'value': '+358 18'
}]
let countryArr = [{
  'label': 'United States of America',
  'value': '+1(US)'
}, {
  'label': 'Australia',
  'value': '+61(AU)'
}, {
  'label': 'Canada',
  'value': '+1(CA)'
}, {
  'label': 'United Kingdom',
  'value': '+44(UK)'
}]
let paymentMethod = [
  'Credit Card',
  'BankTR',
  'PAYPAL',
  'OFFL',
  'CASH'
]

let platform = [
  'Shopify',
  'WooCommerce',
  'eBay',
  'Wish',
  'Amazon',
  'Squarespace',
  'Shopee',
  'Bigcommerce',
  'Shipstation'
]
let onlineShopType = ['Brick and motar only',
  'Brick and motar and Online',
  'Online only',
  'Pop-up Store',
  'Social Media'
]
let businessTypeList = [
  'Wholesaler',
  'Dropshipping',
  'Wholesaler & Dropshipping',
  'Others'
]
let kind = [
  'Concept Store / Gift Store',
  'Wigs Store',
  'Beauty Supply Store',
  'Hair Salon',
  'Nail Salon',
  'Boutique Store',
  'Optical',
  'Shoe Store',
  'Jewelry Store',
  'Accessories Store',
  'Bag Shop',
  'Aroma shop',
  'Home decor Store',
  'Kids Store',
  'Pet Store',
  'Other',
  'Apparel Store'
]
let turnover = [
  '<100k$',
  '100-200k$',
  '200-500k$',
  '500k-1m$',
  '1-5m$',
  '>5m$'
]
let creditLimit = [
  '$1500',
  '$2500',
  '$5000',
  '$7500',
  '$10000',
  '$20000'
]

let desiredLimit = [
  '$1000',
  '$2500',
  '$5000',
  '$7500',
  '$10000'
]
let openYear = [
  'Opening soon',
  'Less than a year',
  'Less than 5 years',
  'More than 5 years'
]

let sources = [
  'Met a commercial in my shop',
  'By a call from ShopVidi',
  'A brand I work with',
  'I received an ShopVidi voucher',
  'Facebook / Instagram',
  'Other social networks (Pinterest, Linkedin...)',
  'Email from ShopVidi',
  'Word of mouth',
  'News / Press',
  'Other'
]
let loadAllCountryCode = [
  {
    'code': 'US',
    'nameEn': 'United States of America',
    'nameCn': '美国'
  },
  {
    'code': 'AU',
    'nameEn': 'Australia',
    'nameCn': '澳大利亚'
  },
  {
    'code': 'CA',
    'nameEn': 'Canada',
    'nameCn': '加拿大'
  },
  {
    'code': 'GB',
    'nameEn': 'United Kingdom',
    'nameCn': '英国'
  },
  {
    'code': 'NZ',
    'nameEn': 'New Zealand',
    'nameCn': '新西兰'
  },
]
let loadAllCountryCodeAll = [
  {
    'code': 'AD',
    'nameEn': 'Andorra',
    'nameCn': '安道尔'
  },
  {
    'code': 'AE',
    'nameEn': 'United Arab Emirates (the)',
    'nameCn': '阿联酋'
  },
  {
    'code': 'AF',
    'nameEn': 'Afghanistan',
    'nameCn': '阿富汗'
  },
  {
    'code': 'AG',
    'nameEn': 'Antigua and Barbuda',
    'nameCn': '安提瓜和巴布达'
  },
  {
    'code': 'AI',
    'nameEn': 'Anguilla',
    'nameCn': '安圭拉'
  },
  {
    'code': 'AL',
    'nameEn': 'Albania',
    'nameCn': '阿尔巴尼亚'
  },
  {
    'code': 'AM',
    'nameEn': 'Armenia',
    'nameCn': '亚美尼亚'
  },
  {
    'code': 'AO',
    'nameEn': 'Angola',
    'nameCn': '安哥拉'
  },
  {
    'code': 'AR',
    'nameEn': 'Argentina',
    'nameCn': '阿根廷'
  },
  {
    'code': 'AS',
    'nameEn': 'American Samoa',
    'nameCn': '美属萨摩亚'
  },
  {
    'code': 'AT',
    'nameEn': 'Austria',
    'nameCn': '奥地利'
  },
  {
    'code': 'AU',
    'nameEn': 'Australia',
    'nameCn': '澳大利亚'
  },
  {
    'code': 'AW',
    'nameEn': 'Aruba',
    'nameCn': '阿鲁巴'
  },
  {
    'code': 'AZ',
    'nameEn': 'Azerbaijan',
    'nameCn': '阿塞拜疆'
  },
  {
    'code': 'BA',
    'nameEn': 'Bosnia and Herzegovina',
    'nameCn': '波黑'
  },
  {
    'code': 'BB',
    'nameEn': 'Barbados',
    'nameCn': '巴巴多斯'
  },
  {
    'code': 'BD',
    'nameEn': 'Bangladesh',
    'nameCn': '孟加拉'
  },
  {
    'code': 'BE',
    'nameEn': 'Belgium',
    'nameCn': '比利时'
  },
  {
    'code': 'BF',
    'nameEn': 'Burkina Faso',
    'nameCn': '布基纳法索'
  },
  {
    'code': 'BG',
    'nameEn': 'Bulgaria',
    'nameCn': '保加利亚'
  },
  {
    'code': 'BH',
    'nameEn': 'Bahrain',
    'nameCn': '巴林'
  },
  {
    'code': 'BI',
    'nameEn': 'Burundi',
    'nameCn': '布隆迪'
  },
  {
    'code': 'BJ',
    'nameEn': 'Benin',
    'nameCn': '贝宁'
  },
  {
    'code': 'BM',
    'nameEn': 'Bermuda',
    'nameCn': '百慕大'
  },
  {
    'code': 'BN',
    'nameEn': 'Brunei Darussalam',
    'nameCn': '文莱'
  },
  {
    'code': 'BO',
    'nameEn': 'Bolivia (Plurinational State nof)',
    'nameCn': '玻利维亚'
  },
  {
    'code': 'BR',
    'nameEn': 'Brazil',
    'nameCn': '巴西'
  },
  {
    'code': 'BS',
    'nameEn': 'Bahamas (the)',
    'nameCn': '巴哈马'
  },
  {
    'code': 'BT',
    'nameEn': 'Bhutan',
    'nameCn': '不丹'
  },
  {
    'code': 'BV',
    'nameEn': 'Bouvet Island',
    'nameCn': '布韦岛'
  },
  {
    'code': 'BW',
    'nameEn': 'Botswana',
    'nameCn': '博茨瓦纳'
  },
  {
    'code': 'BY',
    'nameEn': 'Belarus',
    'nameCn': '白俄罗斯'
  },
  {
    'code': 'BZ',
    'nameEn': 'Belize',
    'nameCn': '伯利兹'
  },
  {
    'code': 'CA',
    'nameEn': 'Canada',
    'nameCn': '加拿大'
  },
  {
    'code': 'CC',
    'nameEn': 'Cocos (Keeling) Islands (the)',
    'nameCn': '科科斯群岛'
  },
  {
    'code': 'CD',
    'nameEn': 'Congo (the Democratic Republic of the)',
    'nameCn': '刚果（金）'
  },
  {
    'code': 'CF',
    'nameEn': 'Central African Republic (the)',
    'nameCn': '中非'
  },
  {
    'code': 'CG',
    'nameEn': 'Congo (the)',
    'nameCn': '刚果（布）'
  },
  {
    'code': 'CH',
    'nameEn': 'Switzerland',
    'nameCn': '瑞士'
  },
  {
    'code': 'CI',
    'nameEn': "Côte d'Ivoire",
    'nameCn': '科特迪瓦'
  },
  {
    'code': 'CK',
    'nameEn': 'Cook Islands (the)',
    'nameCn': '库克群岛'
  },
  {
    'code': 'CL',
    'nameEn': 'Chile',
    'nameCn': '智利'
  },
  {
    'code': 'CM',
    'nameEn': 'Cameroon',
    'nameCn': '喀麦隆'
  },
  {
    'code': 'CN',
    'nameEn': 'China',
    'nameCn': '中国'
  },
  {
    'code': 'CO',
    'nameEn': 'Colombia',
    'nameCn': '哥伦比亚'
  },
  {
    'code': 'CR',
    'nameEn': 'Costa Rica',
    'nameCn': '哥斯达黎加'
  },
  {
    'code': 'CU',
    'nameEn': 'Cuba',
    'nameCn': '古巴'
  },
  {
    'code': 'CV',
    'nameEn': 'Cabo Verde',
    'nameCn': '佛得角'
  },
  {
    'code': 'CW',
    'nameEn': 'Curaçao',
    'nameCn': '库拉索'
  },
  {
    'code': 'CX',
    'nameEn': 'Christmas Island',
    'nameCn': '圣诞岛'
  },
  {
    'code': 'CY',
    'nameEn': 'Cyprus',
    'nameCn': '塞浦路斯'
  },
  {
    'code': 'CZ',
    'nameEn': 'Czechia',
    'nameCn': '捷克'
  },
  {
    'code': 'DE',
    'nameEn': 'Germany',
    'nameCn': '德国'
  },
  {
    'code': 'DJ',
    'nameEn': 'Djibouti',
    'nameCn': '吉布提'
  },
  {
    'code': 'DK',
    'nameEn': 'Denmark',
    'nameCn': '丹麦'
  },
  {
    'code': 'DM',
    'nameEn': 'Dominica',
    'nameCn': '多米尼克'
  },
  {
    'code': 'DO',
    'nameEn': 'Dominican Republic (the)',
    'nameCn': '多米尼加'
  },
  {
    'code': 'DZ',
    'nameEn': 'Algeria',
    'nameCn': '阿尔及利亚'
  },
  {
    'code': 'EC',
    'nameEn': 'Ecuador',
    'nameCn': '厄瓜多尔'
  },
  {
    'code': 'EE',
    'nameEn': 'Estonia',
    'nameCn': '爱沙尼亚'
  },
  {
    'code': 'EG',
    'nameEn': 'Egypt',
    'nameCn': '埃及'
  },
  {
    'code': 'EH',
    'nameEn': 'Western Sahara*',
    'nameCn': '西撒哈拉'
  },
  {
    'code': 'ER',
    'nameEn': 'Eritrea',
    'nameCn': '厄立特里亚'
  },
  {
    'code': 'ES',
    'nameEn': 'Spain',
    'nameCn': '西班牙'
  },
  {
    'code': 'ET',
    'nameEn': 'Ethiopia',
    'nameCn': '埃塞俄比亚'
  },
  {
    'code': 'FI',
    'nameEn': 'Finland',
    'nameCn': '芬兰'
  },
  {
    'code': 'FJ',
    'nameEn': 'Fiji',
    'nameCn': '斐济群岛'
  },
  {
    'code': 'FK',
    'nameEn': 'Falkland Islands (the) [Malvinas]',
    'nameCn': '马尔维纳斯群岛（福克兰）'
  },
  {
    'code': 'FM',
    'nameEn': 'Micronesia (Federated States of)',
    'nameCn': '密克罗尼西亚联邦'
  },
  {
    'code': 'FO',
    'nameEn': 'Faroe Islands (the)',
    'nameCn': '法罗群岛'
  },
  {
    'code': 'FR',
    'nameEn': 'France',
    'nameCn': '法国'
  },
  {
    'code': 'GA',
    'nameEn': 'Gabon',
    'nameCn': '加蓬'
  },
  {
    'code': 'GB',
    'nameEn': 'United Kingdom of Great UK and Northern Irela',
    'nameCn': '英国'
  },
  {
    'code': 'GD',
    'nameEn': 'Grenada',
    'nameCn': '格林纳达'
  },
  {
    'code': 'GE',
    'nameEn': 'Georgia',
    'nameCn': '格鲁吉亚'
  },
  {
    'code': 'GF',
    'nameEn': 'French Guiana',
    'nameCn': '法属圭亚那'
  },
  {
    'code': 'GG',
    'nameEn': 'Guernsey',
    'nameCn': '根西岛'
  },
  {
    'code': 'GH',
    'nameEn': 'Ghana',
    'nameCn': '加纳'
  },
  {
    'code': 'GI',
    'nameEn': 'Gibraltar',
    'nameCn': '直布罗陀'
  },
  {
    'code': 'GL',
    'nameEn': 'Greenland',
    'nameCn': '格陵兰'
  },
  {
    'code': 'GM',
    'nameEn': 'Gambia (the)',
    'nameCn': '冈比亚'
  },
  {
    'code': 'GN',
    'nameEn': 'Guinea',
    'nameCn': '几内亚'
  },
  {
    'code': 'GP',
    'nameEn': 'Guadeloupe',
    'nameCn': '瓜德罗普'
  },
  {
    'code': 'GQ',
    'nameEn': 'Equatorial Guinea',
    'nameCn': '赤道几内亚'
  },
  {
    'code': 'GR',
    'nameEn': 'Greece',
    'nameCn': '希腊'
  },
  {
    'code': 'GS',
    'nameEn': 'South Georgia and the South Sandwich Islands',
    'nameCn': '南乔治亚岛和南桑威奇群岛'
  },
  {
    'code': 'GT',
    'nameEn': 'Guatemala',
    'nameCn': '危地马拉'
  },
  {
    'code': 'GU',
    'nameEn': 'Guam',
    'nameCn': '关岛'
  },
  {
    'code': 'GW',
    'nameEn': 'Guinea-Bissau',
    'nameCn': '几内亚比绍'
  },
  {
    'code': 'GY',
    'nameEn': 'Guyana',
    'nameCn': '圭亚那'
  },
  {
    'code': 'HK',
    'nameEn': 'Hong Kong',
    'nameCn': '香港'
  },
  {
    'code': 'HM',
    'nameEn': 'Heard Island and McDonald Islands',
    'nameCn': '赫德岛和麦克唐纳群岛'
  },
  {
    'code': 'HN',
    'nameEn': 'Honduras',
    'nameCn': '洪都拉斯'
  },
  {
    'code': 'HR',
    'nameEn': 'Croatia',
    'nameCn': '克罗地亚'
  },
  {
    'code': 'HT',
    'nameEn': 'Haiti',
    'nameCn': '海地'
  },
  {
    'code': 'HU',
    'nameEn': 'Hungary',
    'nameCn': '匈牙利'
  },
  {
    'code': 'ID',
    'nameEn': 'Indonesia',
    'nameCn': '印尼'
  },
  {
    'code': 'IE',
    'nameEn': 'Ireland',
    'nameCn': '爱尔兰'
  },
  {
    'code': 'IL',
    'nameEn': 'Israel',
    'nameCn': '以色列'
  },
  {
    'code': 'IN',
    'nameEn': 'India',
    'nameCn': '印度'
  },
  {
    'code': 'IO',
    'nameEn': 'British Indian Ocean Territory (the)',
    'nameCn': '英属印度洋领地'
  },
  {
    'code': 'IQ',
    'nameEn': 'Iraq',
    'nameCn': '伊拉克'
  },
  {
    'code': 'IR',
    'nameEn': 'Iran (Islamic Republic of)',
    'nameCn': '伊朗'
  },
  {
    'code': 'IS',
    'nameEn': 'Iceland',
    'nameCn': '冰岛'
  },
  {
    'code': 'IT',
    'nameEn': 'Italy',
    'nameCn': '意大利'
  },
  {
    'code': 'JE',
    'nameEn': 'Jersey',
    'nameCn': '泽西岛'
  },
  {
    'code': 'JM',
    'nameEn': 'Jamaica',
    'nameCn': '牙买加'
  },
  {
    'code': 'JO',
    'nameEn': 'Jordan',
    'nameCn': '约旦'
  },
  {
    'code': 'JP',
    'nameEn': 'Japan',
    'nameCn': '日本'
  },
  {
    'code': 'KE',
    'nameEn': 'Kenya',
    'nameCn': '肯尼亚'
  },
  {
    'code': 'KG',
    'nameEn': 'Kyrgyzstan',
    'nameCn': '吉尔吉斯斯坦'
  },
  {
    'code': 'KH',
    'nameEn': 'Cambodia',
    'nameCn': '柬埔寨'
  },
  {
    'code': 'KI',
    'nameEn': 'Kiribati',
    'nameCn': '基里巴斯'
  },
  {
    'code': 'KM',
    'nameEn': 'Comoros (the)',
    'nameCn': '科摩罗'
  },
  {
    'code': 'KN',
    'nameEn': 'Saint Kitts and Nevis',
    'nameCn': '圣基茨和尼维斯'
  },
  {
    'code': 'KP',
    'nameEn': "Korea (the Democratic People's Republic of)",
    'nameCn': '朝鲜'
  },
  {
    'code': 'KR',
    'nameEn': 'Korea (the Republic of)',
    'nameCn': '韩国'
  },
  {
    'code': 'KW',
    'nameEn': 'Kuwait',
    'nameCn': '科威特'
  },
  {
    'code': 'KY',
    'nameEn': 'Cayman Islands (the)',
    'nameCn': '开曼群岛'
  },
  {
    'code': 'KZ',
    'nameEn': 'Kazakhstan',
    'nameCn': '哈萨克斯坦'
  },
  {
    'code': 'LA',
    'nameEn': "Lao People's Democratic Republic (the)",
    'nameCn': '老挝'
  },
  {
    'code': 'LB',
    'nameEn': 'Lebanon',
    'nameCn': '黎巴嫩'
  },
  {
    'code': 'LC',
    'nameEn': 'Saint Lucia',
    'nameCn': '圣卢西亚'
  },
  {
    'code': 'LI',
    'nameEn': 'Liechtenstein',
    'nameCn': '列支敦士登'
  },
  {
    'code': 'LK',
    'nameEn': 'Sri Lanka',
    'nameCn': '斯里兰卡'
  },
  {
    'code': 'LR',
    'nameEn': 'Liberia',
    'nameCn': '利比里亚'
  },
  {
    'code': 'LS',
    'nameEn': 'Lesotho',
    'nameCn': '莱索托'
  },
  {
    'code': 'LT',
    'nameEn': 'Lithuania',
    'nameCn': '立陶宛'
  },
  {
    'code': 'LU',
    'nameEn': 'Luxembourg',
    'nameCn': '卢森堡'
  },
  {
    'code': 'LV',
    'nameEn': 'Latvia',
    'nameCn': '拉脱维亚'
  },
  {
    'code': 'LY',
    'nameEn': 'Libya',
    'nameCn': '利比亚'
  },
  {
    'code': 'MA',
    'nameEn': 'Morocco',
    'nameCn': '摩洛哥'
  },
  {
    'code': 'MC',
    'nameEn': 'Monaco',
    'nameCn': '摩纳哥'
  },
  {
    'code': 'MD',
    'nameEn': 'Moldova (the Republic of)',
    'nameCn': '摩尔多瓦'
  },
  {
    'code': 'ME',
    'nameEn': 'Montenegro',
    'nameCn': '黑山'
  },
  {
    'code': 'MG',
    'nameEn': 'Madagascar',
    'nameCn': '马达加斯加'
  },
  {
    'code': 'MH',
    'nameEn': 'Marshall Islands (the)',
    'nameCn': '马绍尔群岛'
  },
  {
    'code': 'MK',
    'nameEn': 'Macedonia (the former Yugoslav Republic of)',
    'nameCn': '马其顿'
  },
  {
    'code': 'ML',
    'nameEn': 'Mali',
    'nameCn': '马里'
  },
  {
    'code': 'MM',
    'nameEn': 'Myanmar',
    'nameCn': '缅甸'
  },
  {
    'code': 'MN',
    'nameEn': 'Mongolia',
    'nameCn': '蒙古国'
  },
  {
    'code': 'MO',
    'nameEn': 'Macao',
    'nameCn': '澳门'
  },
  {
    'code': 'MP',
    'nameEn': 'Northern Mariana Islands (the)',
    'nameCn': '北马里亚纳群岛'
  },
  {
    'code': 'MQ',
    'nameEn': 'Martinique',
    'nameCn': '马提尼克'
  },
  {
    'code': 'MR',
    'nameEn': 'Mauritania',
    'nameCn': '毛里塔尼亚'
  },
  {
    'code': 'MS',
    'nameEn': 'Montserrat',
    'nameCn': '蒙塞拉特岛'
  },
  {
    'code': 'MT',
    'nameEn': 'Malta',
    'nameCn': '马耳他'
  },
  {
    'code': 'MU',
    'nameEn': 'Mauritius',
    'nameCn': '毛里求斯'
  },
  {
    'code': 'MV',
    'nameEn': 'Maldives',
    'nameCn': '马尔代夫'
  },
  {
    'code': 'MW',
    'nameEn': 'Malawi',
    'nameCn': '马拉维'
  },
  {
    'code': 'MX',
    'nameEn': 'Mexico',
    'nameCn': '墨西哥'
  },
  {
    'code': 'MY',
    'nameEn': 'Malaysia',
    'nameCn': '马来西亚'
  },
  {
    'code': 'MZ',
    'nameEn': 'Mozambique',
    'nameCn': '莫桑比克'
  },
  {
    'code': 'NA',
    'nameEn': 'Namibia',
    'nameCn': '纳米比亚'
  },
  {
    'code': 'NC',
    'nameEn': 'New Caledonia',
    'nameCn': '新喀里多尼亚'
  },
  {
    'code': 'NE',
    'nameEn': 'Niger (the)',
    'nameCn': '尼日尔'
  },
  {
    'code': 'NF',
    'nameEn': 'Norfolk Island',
    'nameCn': '诺福克岛'
  },
  {
    'code': 'NG',
    'nameEn': 'Nigeria',
    'nameCn': '尼日利亚'
  },
  {
    'code': 'NI',
    'nameEn': 'Nicaragua',
    'nameCn': '尼加拉瓜'
  },
  {
    'code': 'NL',
    'nameEn': 'Netherlands (the)',
    'nameCn': '荷兰'
  },
  {
    'code': 'NO',
    'nameEn': 'Norway',
    'nameCn': '挪威'
  },
  {
    'code': 'NP',
    'nameEn': 'Nepal',
    'nameCn': '尼泊尔'
  },
  {
    'code': 'NR',
    'nameEn': 'Nauru',
    'nameCn': '瑙鲁'
  },
  {
    'code': 'NU',
    'nameEn': 'Niue',
    'nameCn': '纽埃'
  },
  {
    'code': 'NZ',
    'nameEn': 'New Zealand',
    'nameCn': '新西兰'
  },
  {
    'code': 'OM',
    'nameEn': 'Oman',
    'nameCn': '阿曼'
  },
  {
    'code': 'PA',
    'nameEn': 'Panama',
    'nameCn': '巴拿马'
  },
  {
    'code': 'PE',
    'nameEn': 'Peru',
    'nameCn': '秘鲁'
  },
  {
    'code': 'PG',
    'nameEn': 'Papua New Guinea',
    'nameCn': '巴布亚新几内亚'
  },
  {
    'code': 'PH',
    'nameEn': 'Philippines (the)',
    'nameCn': '菲律宾'
  },
  {
    'code': 'PK',
    'nameEn': 'Pakistan',
    'nameCn': '巴基斯坦'
  },
  {
    'code': 'PL',
    'nameEn': 'Poland',
    'nameCn': '波兰'
  },
  {
    'code': 'PM',
    'nameEn': 'Saint Pierre and Miquelon',
    'nameCn': '圣皮埃尔和密克隆'
  },
  {
    'code': 'PN',
    'nameEn': 'Pitcairn',
    'nameCn': '皮特凯恩群岛'
  },
  {
    'code': 'PR',
    'nameEn': 'Puerto Rico',
    'nameCn': '波多黎各'
  },
  {
    'code': 'PT',
    'nameEn': 'Portugal',
    'nameCn': '葡萄牙'
  },
  {
    'code': 'PW',
    'nameEn': 'Palau',
    'nameCn': '帕劳'
  },
  {
    'code': 'PY',
    'nameEn': 'Paraguay',
    'nameCn': '巴拉圭'
  },
  {
    'code': 'QA',
    'nameEn': 'Qatar',
    'nameCn': '卡塔尔'
  },
  {
    'code': 'RE',
    'nameEn': 'Réunion',
    'nameCn': '留尼汪'
  },
  {
    'code': 'RO',
    'nameEn': 'Romania',
    'nameCn': '罗马尼亚'
  },
  {
    'code': 'RS',
    'nameEn': 'Serbia',
    'nameCn': '塞尔维亚'
  },
  {
    'code': 'RU',
    'nameEn': 'Russian Federation (the)',
    'nameCn': '俄罗斯'
  },
  {
    'code': 'RW',
    'nameEn': 'Rwanda',
    'nameCn': '卢旺达'
  },
  {
    'code': 'SA',
    'nameEn': 'Saudi Arabia',
    'nameCn': '沙特阿拉伯'
  },
  {
    'code': 'SB',
    'nameEn': 'Solomon Islands',
    'nameCn': '所罗门群岛'
  },
  {
    'code': 'SC',
    'nameEn': 'Seychelles',
    'nameCn': '塞舌尔'
  },
  {
    'code': 'SD',
    'nameEn': 'Sudan (the)',
    'nameCn': '苏丹'
  },
  {
    'code': 'SE',
    'nameEn': 'Sweden',
    'nameCn': '瑞典'
  },
  {
    'code': 'SG',
    'nameEn': 'Singapore',
    'nameCn': '新加坡'
  },
  {
    'code': 'SH',
    'nameEn': 'Saint Helena, Ascension and Tristan da Cunha',
    'nameCn': '圣赫勒拿'
  },
  {
    'code': 'SI',
    'nameEn': 'Slovenia',
    'nameCn': '斯洛文尼亚'
  },
  {
    'code': 'SK',
    'nameEn': 'Slovakia',
    'nameCn': '斯洛伐克'
  },
  {
    'code': 'SL',
    'nameEn': 'Sierra Leone',
    'nameCn': '塞拉利昂'
  },
  {
    'code': 'SM',
    'nameEn': 'San Marino',
    'nameCn': '圣马力诺'
  },
  {
    'code': 'SN',
    'nameEn': 'Senegal',
    'nameCn': '塞内加尔'
  },
  {
    'code': 'SO',
    'nameEn': 'Somalia',
    'nameCn': '索马里'
  },
  {
    'code': 'SR',
    'nameEn': 'Suriname',
    'nameCn': '苏里南'
  },
  {
    'code': 'SS',
    'nameEn': 'South Sudan',
    'nameCn': '南苏丹'
  },
  {
    'code': 'ST',
    'nameEn': 'Sao Tome and Principe',
    'nameCn': '圣多美和普林西比'
  },
  {
    'code': 'SV',
    'nameEn': 'El Salvador',
    'nameCn': '萨尔瓦多'
  },
  {
    'code': 'SY',
    'nameEn': 'Syrian Arab Republic',
    'nameCn': '叙利亚'
  },
  {
    'code': 'SZ',
    'nameEn': 'Swaziland',
    'nameCn': '斯威士兰'
  },
  {
    'code': 'TC',
    'nameEn': 'Turks and Caicos Islands (the)',
    'nameCn': '特克斯和凯科斯群岛'
  },
  {
    'code': 'TD',
    'nameEn': 'Chad',
    'nameCn': '乍得'
  },
  {
    'code': 'TG',
    'nameEn': 'Togo',
    'nameCn': '多哥'
  },
  {
    'code': 'TH',
    'nameEn': 'Thailand',
    'nameCn': '泰国'
  },
  {
    'code': 'TJ',
    'nameEn': 'Tajikistan',
    'nameCn': '塔吉克斯坦'
  },
  {
    'code': 'TK',
    'nameEn': 'Tokelau',
    'nameCn': '托克劳'
  },
  {
    'code': 'TL',
    'nameEn': 'Timor-Leste',
    'nameCn': '东帝汶'
  },
  {
    'code': 'TM',
    'nameEn': 'Turkmenistan',
    'nameCn': '土库曼斯坦'
  },
  {
    'code': 'TN',
    'nameEn': 'Tunisia',
    'nameCn': '突尼斯'
  },
  {
    'code': 'TO',
    'nameEn': 'Tonga',
    'nameCn': '汤加'
  },
  {
    'code': 'TR',
    'nameEn': 'Turkey',
    'nameCn': '土耳其'
  },
  {
    'code': 'TT',
    'nameEn': 'Trinidad and Tobago',
    'nameCn': '特立尼达和多巴哥'
  },
  {
    'code': 'TV',
    'nameEn': 'Tuvalu',
    'nameCn': '图瓦卢'
  },
  {
    'code': 'TW',
    'nameEn': 'Taiwan (Province of China)',
    'nameCn': '台湾'
  },
  {
    'code': 'TZ',
    'nameEn': 'Tanzania, United Republic of',
    'nameCn': '坦桑尼亚'
  },
  {
    'code': 'UA',
    'nameEn': 'Ukraine',
    'nameCn': '乌克兰'
  },
  {
    'code': 'UG',
    'nameEn': 'Uganda',
    'nameCn': '乌干达'
  },
  {
    'code': 'US',
    'nameEn': 'United States of America',
    'nameCn': '美国'
  },
  {
    'code': 'UY',
    'nameEn': 'Uruguay',
    'nameCn': '乌拉圭'
  },
  {
    'code': 'UZ',
    'nameEn': 'Uzbekistan',
    'nameCn': '乌兹别克斯坦'
  },
  {
    'code': 'VA',
    'nameEn': 'Holy See (the)',
    'nameCn': '梵蒂冈'
  },
  {
    'code': 'VC',
    'nameEn': 'Saint Vincent and the Grenadines',
    'nameCn': '圣文森特和格林纳丁斯'
  },
  {
    'code': 'VE',
    'nameEn': 'Venezuela (Bolivarian Republic of)',
    'nameCn': '委内瑞拉'
  },
  {
    'code': 'VG',
    'nameEn': 'Virgin Islands (British)',
    'nameCn': '英属维尔京群岛'
  },
  {
    'code': 'VI',
    'nameEn': 'Virgin Islands (U.S.)',
    'nameCn': '美属维尔京群岛'
  },
  {
    'code': 'VN',
    'nameEn': 'Viet Nam',
    'nameCn': '越南'
  },
  {
    'code': 'VU',
    'nameEn': 'Vanuatu',
    'nameCn': '瓦努阿图'
  },
  {
    'code': 'WF',
    'nameEn': 'Wallis and Futuna',
    'nameCn': '瓦利斯和富图纳'
  },
  {
    'code': 'WS',
    'nameEn': 'Samoa',
    'nameCn': '萨摩亚'
  },
  {
    'code': 'YE',
    'nameEn': 'Yemen',
    'nameCn': '也门'
  },
  {
    'code': 'YK',
    'nameEn': 'The Republic of Kosovo',
    'nameCn': '科索沃共和国'
  },
  {
    'code': 'YT',
    'nameEn': 'Mayotte',
    'nameCn': '马约特'
  },
  {
    'code': 'ZA',
    'nameEn': 'South Africa',
    'nameCn': '南非'
  },
  {
    'code': 'ZM',
    'nameEn': 'Zambia',
    'nameCn': '赞比亚'
  },
  {
    'code': 'ZW',
    'nameEn': 'Zimbabwe',
    'nameCn': '津巴布韦'
  }
]
let uploadProofOfIdentity = [
  'Resident permit ID/U.S.Green Card',
  'Passport',
  'Driver license'
]
let hairMaterialOption = [
  'Human Hair',
  'Synthetic',
  'Blend'
]
let hairTypeOption = [
  'Brazilian',
  'Peruvian',
  'Malaysian',
  'Indian'
]
let hairTextureOption = [
  'Straight',
  'Body Wave',
  'Deep Wave',
  'Loose Wave',
  'Curly Hair',
  'Water Wave',
  'Kinky Curly',
  'Kinky Straight'
]
let hairLaceDesignOption = [
  'HD Lace',
  '13x4 Lace Frontal',
  '13x6 Lace Frontal',
  '4x4 Lace',
  'V part Lace',
  'T Lace',
  'Lace Part',
  'Headband',
  'Full Lace',
  '360 Lace Frontal',
  '5x5 Lace',
  'Ready-to-Wear'
]
let hairColorOption = [
  'Natural Black',
  'Blonde',
  'Ombre Color',
  'Brown'
]
let dressesStyleOption = [
  'Casual',
  'Sexy',
  'Elegant',
  'Formal',
  'Party Dress',
  'Bohemian',
  'Sweet',
  'Streetwear',
  'European',
  'Luxury',
  'Office Lady',
  'vintage',
  'Muslim Style'
]

let dressesDesignOption = [
  'Front Slit',
  'Skinny Style',
  'Backless',
  'Deep V',
  'Above Knee',
  'Off Shoulder',
  'Wrapped Chest',
  'Irregular',
  'Hollow',
  'Side Slit',
  'Slimming',
  'High Waist',
  'Strapless',
  'Loose',
  'Plus Size',
  'With Rhinestone',
  'Lace Up',
  'Contrast Color',
  'Tassels',
  'One Shoulder',
  'Two Piece'
]
let dressesFabricTypeOption = [
  'Polyester',
  'Knitted',
  'Spandex',
  'Cotton',
  'Woven',
  'Chiffon',
  'Worsted',
  'Satin',
  'Mesh',
  'Woolen',
  'Silk',
  'Crepe',
  'Velvet',
  'Denim',
  'Rayon',
  'Linen',
  'Organza',
  'Taffeta'
]
let dressesOccasionOption = [
  'Daily Life',
  'Work',
  'Beach',
  'Evening Party',
  'Wedding',
  'Prom',
  'Holiday',
  'Party Wear',
  'Banquet',
  'Home'
]
export default {
  countryArr,
  countryArrAll,
  platform,
  onlineShopType,
  kind,
  turnover,
  openYear,
  sources,
  businessTypeList,
  loadAllCountryCode,
  loadAllCountryCodeAll,
  desiredLimit,
  creditLimit,
  uploadProofOfIdentity,
  paymentMethod,
  hairMaterialOption,
  hairTypeOption,
  hairTextureOption,
  hairLaceDesignOption,
  hairColorOption,

  dressesStyleOption,
  dressesDesignOption,
  dressesFabricTypeOption,
  dressesOccasionOption
}



// WEBPACK FOOTER //
// ./src/pages/components/code.js